import React from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Space,
  InputNumber,
} from 'antd';
import moment from 'moment';
import DebounceSelect from '../../Forms/DebounceSelect';
import formatAmount from 'indian-currency-formatter';
import * as Config from '../../../appConfig';
import { activePeriod, disabledDate, isSunday } from '../../../utils/date';

const AddAllowanceForm = ({
  allowance,
  lookupData,
  onLookup,
  types,
  onAllowanceSubmit,
  onCancelClick,
  fetching,
  ability,
}) => {
  const [form] = Form.useForm();

  const [selectedEmployee, setSelectedEmployee] = React.useState(
    allowance
      ? {
          value: `${allowance.employee.id}`,
          label: `${allowance.employee.first_name} ${allowance.employee.last_name} (${allowance.employee.emp_id})`,
        }
      : {}
  );

  console.log('selectedEmployee ////', selectedEmployee);

  const [freezePrevMonth, currentMonth, prevMonth] = activePeriod();

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        size="large"
        className="ant-form-custom"
        initialValues={{
          id: allowance && allowance.id,
          allowance_type_id:
            allowance &&
            allowance.allowance_type &&
            allowance.allowance_type.id,
          for_month:
            allowance && allowance.for_month && moment(allowance.for_month),
          amount: allowance && allowance.amount,
          note: allowance && allowance.note,
          employee: selectedEmployee,
        }}
        onFinish={(values) =>
          onAllowanceSubmit(values, (updated) => {
            if (updated.status === 2) {
              // setShowRelieveModal(false);
            }
          })
        }
        style={{ marginTop: '0' }}
      >
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Employee"
              name="employee"
              rules={[
                {
                  required: true,
                  message: 'Please input Employee!',
                },
              ]}
            >
              <DebounceSelect
                showSearch={allowance && allowance.id ? false : true}
                disabled={allowance && allowance.id ? true : false}
                defaultValue={selectedEmployee}
                value={selectedEmployee}
                placeholder="Search employee"
                data={
                  lookupData && lookupData.length
                    ? lookupData
                    : allowance
                    ? [
                        {
                          label: `${allowance.employee.first_name} ${allowance.employee.last_name} (${allowance.employee.emp_id})`,
                          value: allowance.employee.id,
                        },
                      ]
                    : []
                }
                onLookup={onLookup}
                onChange={(newValue) => {
                  setSelectedEmployee(newValue);
                }}
                style={{
                  width: '100%',
                }}
                fetching={fetching}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Allowance Type"
              name="allowance_type_id"
              rules={[
                {
                  required: true,
                  message: 'Please select Allowance Type!',
                },
              ]}
            >
              <Select placeholder="Please select">
                {types &&
                  types.map((type) => (
                    <Select.Option key={type.id} value={type.id}>
                      {type.name} ({type.code})
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Month"
              name="for_month"
              rules={[
                {
                  required: true,
                  message: 'Please select Month!',
                },
              ]}
            >
              <DatePicker
                disabledDate={(current) =>
                  disabledDate(
                    current,
                    freezePrevMonth,
                    currentMonth,
                    prevMonth
                  ) || isSunday(current)
                }
                format={Config.DATE_MONTH_INPUT}
                picker="month"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Amount"
              name="amount"
              rules={[
                {
                  required: true,
                  message: 'Please input Amount!',
                },
              ]}
            >
              <InputNumber
                formatter={(value) => formatAmount(value)}
                parser={(value) => value.replace(/(,*)/g, '')}
                style={{
                  width: '170px',
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item label="Note" name="note">
              <Input placeholder="Note" maxLength="255" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} align="right">
            <Space>
              <Button type="secondary" size="middle" onClick={onCancelClick}>
                Cancel
              </Button>
              <Button type="primary" size="middle" htmlType="submit">
                Save
              </Button>
            </Space>
          </Col>
        </Row>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
      </Form>
    </>
  );
};

export default AddAllowanceForm;
